import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { currentStateState, selectedCurrentStateActionState } from '../../../storage/client';
import { CurrentStateAction } from '../../../types/currentState';
import CurrentStateList from '../../currentState/CurrentStateList';
import CurrentStateModal from '../../currentState/modal/CurrentStateModal';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';

function PublicLivePage() {
  const { theme } = useStyles();
  const [action, setAction] = useRecoilState(selectedCurrentStateActionState);
  const currentState = useRecoilValue(currentStateState(action?.ident ?? ''));

  const closeAction = () => {
    setAction(undefined);
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      <FloatingCardsLayout
        contentSize={1.54}
        content={
          <FloatingCardContent
            flexible
            gap={theme.sizing.scale600}
          >
            <CurrentStateList />
          </FloatingCardContent>
        }
      />
      <CurrentStateModal
        onClose={closeAction}
        isOpen={action?.name === CurrentStateAction.info}
        ident={currentState?.ident}
      />
    </>
  );
}

export default PublicLivePage;
